// @flow
import React, { PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';
import type { QuestionType, ThemeType } from 'types/Faq';
import ContactForm from 'containers/contact/ContactFormContainer';
import ContactFormOffre from 'containers/contact/ContactFormOffreContainer';

export type StateProps = {
  contacts: {
    adresse: string,
    adresse_map: string,
    telephone: string,
    email: string,
    horaires: string
  },
  themes?: ThemeType[],
  questions: QuestionType[]
};

type Props = {
  match: {
    params: {
      slugTheme: string
    }
  },
  location: any,
  history: any
} & StateProps;

class ContactList extends PureComponent<Props>{
  static defaultProps= {
    theme: '',
    form: false
  };

  renderQuestions = (filteredQuestions: Array<QuestionType>): any => {
    const { themes } = this.props;

    if (!themes || themes.length === 0) {
      return null;
    }

    return filteredQuestions.map((question, index) => {
      const filteredTheme = themes.filter(theme => theme.id === question.theme);
      if (question.link) {
        return(
          <Link to={question.link} key={index}
            className="link-chevron link-chevron--din"
            data-label="">
            <span>{question.title}</span>
            <i className="icon icon-chevron-right"></i>
          </Link>
        );
      }
      return (
        <Link to={`/faq/${filteredTheme[0].slug}/${question.slug}`} key={index}
          className="link-chevron link-chevron--din"
          data-label="">
          <span>{question.title}</span>
          <i className="icon icon-chevron-right"></i>
        </Link>
      );
    });
  }

  renderContactContent = () => {
    const { questions, themes, location: { state: locationState } } = this.props;
    const { slugTheme } = this.props.match.params;
    if (slugTheme === 'nous-contacter') {
      if (locationState) {
        const { object } = locationState;
        if (object === 'Proposition de poste') {
          return <ContactFormOffre />;
        }
      }
      return <ContactForm />;
    }

    if (!themes || themes.length === 0) {
      return null;
    }

    const filteredThemes = themes.filter(theme => theme.slug === slugTheme);
    if (slugTheme === 'proposition-poste' || slugTheme.match('proposition-poste')) {
      return <ContactFormOffre />;
    }

    if (filteredThemes.length === 0) {
      this.props.history.push('/contact/nous-contacter');
    }

    const filteredQuestions = questions.filter(question => question.theme === filteredThemes[0].id);
    if (filteredThemes.length > 0 && filteredThemes[0].page_liee && filteredThemes[0].page_liee_link) {
      filteredQuestions.push({
        id: filteredThemes[0].page_liee,
        theme: filteredThemes[0].id,
        link: filteredThemes[0].page_liee_link,
        title: 'Voir la rubrique dédiée',
        content: '',
        label: {
          name: filteredThemes[0].name,
          slug: filteredThemes[0].slug,
          id: filteredThemes[0].id,
        },
        meta_description: '',
        meta_title: '',
        menu_order: 0,
        slug: '',
        typeFlow: 'QuestionType',
      });
    }
    if (filteredQuestions.length === 0 && filteredThemes.length > 0) {
      let state = {
        object: filteredThemes[0].name,
      };
      if (filteredThemes[0].slug === 'hospitalites') {
        state = {
          object: `Demande d'offre hospitalité`,
          isPopulate: true,
          isOffer: true,
        };
      }
      if (filteredThemes[0].slug === 'proposition-emploi') {
        state = {
          object: `Candidature Spontanée`,
          isPopulate: true,
          isOffer: false,
        };
      }
      return (
        <Redirect
          to={{
            pathname: `/contact/nous-contacter`,
            state: state,
          }}
        />
      );
    }
    return (
      <React.Fragment>
        { filteredQuestions.length > 0 &&
          <div className="block-contact__faq">
            <h3>Cela pourrait vous être utile</h3>
            {this.renderQuestions(filteredQuestions)}
          </div>
        }
        <div className="block-contact__write">
          <h4 className="ft-h3">Vous ne trouvez pas ce que vous cherchez ?</h4>
          <p>Envoyez-nous un message, nous vous répondrons aussi rapidement que possible.</p>
          <Link to={{
              pathname: `/contact/nous-contacter`,
              state: {
                object: filteredThemes.length > 0 ? filteredThemes[0].name : 'Nous contacter',
              },
            }}>
            <button className="btn btn--primary js-contact-write">
                Nous écrire
            </button>
          </Link>
        </div>
      </React.Fragment>
    );
  }

  render(){
    return (
      <div className="row mb-lg-8 mb-4">
        <div className="col col-lg-8 col-lg-offset-2">
          <div className="box block-contact mt-5">
            {this.renderContactContent()}
          </div>
        </div>
      </div>
    );
  }
}

export default ContactList;
